module.exports = __webpack_public_path__ + "img/mushroom_in_the_woods.82334b3d.jpg";